module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/d8baa2e6de54aedc8ff9fcb31bacfdb5.png";